export default {
  getList: {
    method: 'post',
    url: '/client/routing/list'
  },
  getAll: {
    method: 'post',
    url: '/client/routing/get-all'
  },
  get: {
    method: 'get',
    url: '/client/routing/id'
  },
  addRouting: {
    method: 'post',
    url: '/client/routing'
  },
  update: {
    method: 'put',
    url: '/client/routing'
  },
  delete: {
    method: 'delete',
    url: '/client/routing'
  }
  // updateRelationNode: {
  //   method: 'post',
  //   url: '/client/node/update-relation-node'
  // },
  // findNodes: {
  //   method: 'get',
  //   url: '/client/node/find?key=KEY&type=nodeType'
  // },
  // getHistory: {
  //   method: 'post',
  //   url: '/client/node/history/list'
  // },
  // getNodeTypes: {
  //   method: 'get',
  //   url: '/client/node/types'
  // },
  // getTransportTypes: {
  //   method: 'get',
  //   url: '/client/node/transport-types'
  // },
  // getNodeAndWareHouseTypes: {
  //   method: 'get',
  //   url: '/client/node/node-and-warehouse-types'
  // }
}
